import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Input,
  Dropdown,
  Button
} from 'semantic-ui-react'

const CardORCancelListUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardORCancelList"
        style={{padding: "15px"}}>
        <Form
          id="CardORCancelListUX-Form-48">
          <FormGroup
            id="CardORCancelListUX-FormGroup-49">
            <FormField
              id="CardORCancelListUX-FormField-51"
              width={4}>
              <Checkbox
                checked={props.ORCancelListSequence?.orFilter?.checkedHn}
                id="CardORCancelListUX-Checkbox-55"
                label={props.languageUX === "en" ? "HN" : "HN"}
                name="checkedHn"
                onChange={props.onChangeFilter}
                style={{fontWeight: "bold", marginBottom: "0.45rem"}}>
              </Checkbox>
              <div
                id="CardORCancelListUX-div-60"
                style={{width: "100%"}}>
                {props.patientSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-52"
              width={4}>
              <label
                id="CardORCancelListUX-label-56">
                {props.languageUX === "en" ? "Patient Name" : "ชื่อ-สกุลผู้ป่วย"}
              </label>
              <Input
                disabled={true}
                fluid={true}
                id="CardORCancelListUX-Input-57"
                style={{opacity:1}}
                value={props.ORCancelListSequence?.orFilter?.patientFullName || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-53"
              width={4}>
              <Checkbox
                checked={props.ORCancelListSequence?.orFilter?.checkedDoctor}
                id="CardORCancelListUX-Checkbox-58"
                label={props.languageUX === "en" ? "Surgeon" : "แพทย์ผ่าตัด"}
                name="checkedDoctor"
                onChange={props.onChangeFilter}
                style={{fontWeight: "bold",marginBottom: "0.45rem"}}>
              </Checkbox>
              <div
                id="CardORCancelListUX-div-59"
                style={{width: "100%"}}>
                {props.doctorSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-54"
              width={4}>
              <label
                id="CardORCancelListUX-label-61">
                Location
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardORCancelListUX-Dropdown-62"
                name="operating_detail__operating_room__location_id"
                onChange={props.onChangeLocation}
                options={props.locationOptions || []}
                search={true}
                selection={true}
                style={{minWidth: "100%", width: 0}}
                value={props.ORCancelListSequence?.orFilter?.operating_detail__operating_room__location_id || ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORCancelListUX-FormGroup-50">
            <FormField
              id="CardORCancelListUX-FormField-63"
              width={3}>
              <label
                id="CardORCancelListUX-label-69">
                {props.languageUX === "en" ? "Date of Surgery" : "วันที่ผ่าตัด"}
              </label>
              <div
                id="CardORCancelListUX-div-70"
                style={{width: "100%"}}>
                {props.startDateTextBox}
              </div>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-64">
              <label
                id="CardORCancelListUX-label-71">
                {"\u00a0"}
              </label>
              <label
                id="CardORCancelListUX-label-72"
                style={{height: "100%", display: "flex", alignItems: "center", marginTop: "-0.75rem"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-65"
              width={3}>
              <label
                id="CardORCancelListUX-label-73">
                {"\u00a0"}
              </label>
              <div
                id="CardORCancelListUX-div-74"
                style={{width: "100%"}}>
                {props.endDateTextBox}
              </div>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-66"
              width={3}>
              <label
                id="CardORCancelListUX-label-75">
                {props.languageUX === "en" ? "Date Surgery Scheduled" : "วันที่จองผ่าตัด"}
              </label>
              <div
                id="CardORCancelListUX-div-76"
                style={{width: "100%"}}>
                {props.createdDateTextBox}
              </div>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-67"
              width={3}>
              <label
                id="CardORCancelListUX-label-77">
                {props.languageUX === "en" ? "Room" : "ห้อง"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardORCancelListUX-Dropdown-78"
                name="operating_detail__operating_room__id"
                onChange={props.onChangeFilter}
                options={props.roomOptions || []}
                search={true}
                selection={true}
                style={{width: 0, minWidth: "100%"}}
                value={props.ORCancelListSequence?.orFilter?.operating_detail__operating_room__id || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-68"
              inline={true}>
              <label
                id="CardORCancelListUX-label-88"
                style={{marginBottom: "0.5rem"}}>
                {"\u00a0"}
              </label>
              <div
                id="CardORCancelListUX-div-79">
                {props.buttonSearch}
              </div>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-82">
              <label
                id="CardORCancelListUX-label-85"
                style={{marginBottom: "0.5rem"}}>
                {"\u00a0"}
              </label>
              <Button
                color="yellow"
                id="CardORCancelListUX-Button-86"
                onClick={props.onClear}
                size="small"
                style={{minWidth: "max-content", margin: 0}}>
                {props.languageUX === "en" ? "Clear" : "ล้างการค้นหา"}
              </Button>
            </FormField>
            <FormField
              id="CardORCancelListUX-FormField-83">
              <label
                id="CardORCancelListUX-label-84"
                style={{marginBottom: "0.5rem"}}>
                {"\u00a0"}
              </label>
              <div
                id="CardORCancelListUX-div-87">
                {props.buttonPrint}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardORCancelListUX-div-22">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.ORCancelListSequence?.cancelOrder?.items || []}
            headers={props.languageUX === "en" ? "Date of Surgery, HN, Patient Details, Location/Room, Surgeon, Diagnosis, Type, Operation, Special Equipment, Blood, Anesthesia  " : "วันที่ผ่าตัด, HN, ข้อมูลผู้ป่วย, สถานที่/ห้อง, แพทย์ผ่าตัด, Diagnosis, Type, Operation, Special Equipment, Blood, Anesthesia"}
            id="CardORCancelListUX-Table-33"
            keys="start_date, hn, patient_name, locationRoom, primary_doctor_name, diagnosis, typeLabel, pre_operation_summary, special_equipments_text, blood_request_summary, anesthesia_method_name"
            minRows={10}
            showPagination={false}
            style={{height: "calc(100dvh - 21rem)"}}
            widths="^90,^85,^100,^100,^100,^100,^100,^120,^90,^70,^90">
          </Table>
        </div>
      </div>
    )
}


export default CardORCancelListUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelList"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-div-22"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 33,
      "name": "Table",
      "parent": 22,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.ORCancelListSequence?.cancelOrder?.items || []"
        },
        "headers": {
          "type": "value",
          "value": "วันที่ผ่าตัด, HN, ข้อมูลผู้ป่วย, สถานที่/ห้อง, แพทย์ผ่าตัด, Diagnosis, Type, Operation, Special Equipment, Blood, Anesthesia",
          "valueEN": "Date of Surgery, HN, Patient Details, Location/Room, Surgeon, Diagnosis, Type, Operation, Special Equipment, Blood, Anesthesia  "
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-Table-33"
        },
        "keys": {
          "type": "value",
          "value": "start_date, hn, patient_name, locationRoom, primary_doctor_name, diagnosis, typeLabel, pre_operation_summary, special_equipments_text, blood_request_summary, anesthesia_method_name"
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100dvh - 21rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^90,^85,^100,^100,^100,^100,^100,^120,^90,^70,^90"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-Form-48"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormGroup-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormGroup-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-51"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-52"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-53"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-54"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Checkbox",
      "parent": 51,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ORCancelListSequence?.orFilter?.checkedHn"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-Checkbox-55"
        },
        "label": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "name": {
          "type": "value",
          "value": "checkedHn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginBottom: \"0.45rem\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ-สกุลผู้ป่วย",
          "valueEN": "Patient Name"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Input",
      "parent": 52,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-Input-57"
        },
        "style": {
          "type": "code",
          "value": "{opacity:1}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCancelListSequence?.orFilter?.patientFullName || \"\""
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Checkbox",
      "parent": 53,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ORCancelListSequence?.orFilter?.checkedDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-Checkbox-58"
        },
        "label": {
          "type": "value",
          "value": "แพทย์ผ่าตัด",
          "valueEN": "Surgeon"
        },
        "name": {
          "type": "value",
          "value": "checkedDoctor"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",marginBottom: \"0.45rem\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "Location"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-61"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Dropdown",
      "parent": 54,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-Dropdown-62"
        },
        "name": {
          "type": "value",
          "value": "operating_detail__operating_room__location_id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeLocation"
        },
        "options": {
          "type": "code",
          "value": "props.locationOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"100%\", width: 0}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCancelListSequence?.orFilter?.operating_detail__operating_room__location_id || \"\""
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-63"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-65"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-66"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-67"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ผ่าตัด",
          "valueEN": "Date of Surgery"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "code",
          "value": "props.startDateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-72"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", display: \"flex\", alignItems: \"center\", marginTop: \"-0.75rem\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-73"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "code",
          "value": "props.endDateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่จองผ่าตัด",
          "valueEN": "Date Surgery Scheduled"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-75"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "props.createdDateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "ห้อง",
          "valueEN": "Room"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-77"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-Dropdown-78"
        },
        "name": {
          "type": "value",
          "value": "operating_detail__operating_room__id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.roomOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: 0, minWidth: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCancelListSequence?.orFilter?.operating_detail__operating_room__id || \"\""
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-div-79"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-FormField-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-84"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "label",
      "parent": 82,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-85"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Button",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างการค้นหา",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-Button-86"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", margin: 0}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 83,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-div-87"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "label",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCancelListUX-label-88"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 79,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "CardORCancelListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
